// extracted by mini-css-extract-plugin
export var downArrow = "_a8-0";
export var infoTooltipIcon = "_a8-3";
export var label = "_a8-1";
export var optionCard = "_a8-4";
export var upArrow = "_a8-2";